<template>
  <div>
    <div ref="smallMap" v-show="smallMapDisplay">
      <e6-box
        ref="mapBox"
        :title="title"
        class="smallmapBox"
        @closeFun="closeMap"
      >
        <div style="margin:20px;">
          地图标注
          <input ref="pickerInput" class="mapInput" />
          <!-- <span class="mapBtn" @click="serachLocation">搜索</span> -->
          <span
            class="mapBtn_blude"
            @click="drawMarker"
            style="margin-right:0;padding:5px 8px;"
            title="标点"
            >标点</span
          >
        </div>
        <div style="position:relative;height:345px;">
          <!-- <el-amap
            class="mapDiv"
            id="amapContainer"
            style="width:100%;height:100%;"
          ></el-amap> -->
          <e6-map v-loading="mapLoading" belong="AMap" @ready="mapReady" />
        </div>
        <div style="margin:20px;text-align: right;">
          <span class="mapBtn_blude" @click="sureMap">确定使用该地址</span>
          <span class="mapBtn" @click="cancelMap">取消</span>
        </div>
      </e6-box>
    </div>
    <div ref="mask" class="maskDiv" v-show="showMask"></div>
  </div>
</template>

<script>
// import { lazyAMapApiLoaderInstance } from "vue-amap";
// import { GaodeAPI } from "@/utils/map/gaodeAPI.js";
import e6Box from "@/components/e6Box";
import e6Map from "e6-base-ui/packages/e6Map";
export default {
  name: "smallMap",
  components: { e6Box, e6Map },
  props: {
    optionMap: {
      type: Object,
      default: function() {
        return {
          lng: "",
          lat: "",
          city: "",
          level: "",
          location: ""
        };
      }
    },
    title: {
      type: String,
      default: ""
    },
    city: {
      type: String,
      default: ""
    }
  },
  watch: {
    optionMap: {
      handler: function() {
        if (this.optionMap.location != "") {
          this.location = this.optionMap.location;
          // 如果经纬度存在的话，优先使用经纬度
          if (this.optionMap.lng !== "" && this.optionMap.lat !== "") {
            // 展示点
            this.getLocationBack({
              lat: this.optionMap.lat,
              lng: this.optionMap.lng
            });
            // 展示信息弹窗
            this.showInfoOver(
              [this.optionMap.lng, this.optionMap.lat],
              this.location
            );
          } else {
            this.serachLocation();
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      close: false, // 关闭
      mapAPI: null,
      map: null, //地图实例
      smallMapDisplay: "none",

      E6Map: null, // 地图构造函数
      mapLoading: false,
      polygons: [], //地图中心市区边界
      marker: null,
      location: "",
      lon: 0,
      lat: 0,
      showMask: false,
      infoWindow: null //信息窗体
    };
  },
  methods: {
    async mapReady({ E6Map, map }) {
      this.E6Map = E6Map; //地图构造函数
      this.map = map; //地图实例对象
      this.mapLoading = true;
      await import("@/utils/map/gaodeAPI.js").then(module => {
        this.mapAPI = new module.GaodeAPI(map); //根据地图实例初始化地图API
        if (AMap !== undefined) {
          AMap.plugin(
            ["AMap.MouseTool", "AMap.Geocoder", "AMap.DistrictSearch"],
            function() {}
          );
        }
      });
      this.mapLoading = false;
    },
    //加载POI需要的UI
    getAMapUI() {
      return new Promise(resolve => {
        const $script = document.createElement("script");
        $script.type = "text/javascript";
        $script.src = "http://webapi.amap.com/ui/1.0/main.js?v=1.0.11";
        global.document.body.appendChild($script);
        $script.addEventListener("load", resolve);
      });
    },

    // 根据城市名获取行政区域，用于设置地图中心视口
    getAreaByCity(city, level) {
      // 如果当前地图配置中存在经纬度，则以该经纬度为中心点
      if (this.optionMap.lng !== "" && this.optionMap.lat !== "") {
        this.mapAPI.setCenter([this.optionMap.lng, this.optionMap.lat]);
      } else if (city === "" && level === "") {
        // 如果城市和城市level为空，则说明当前是编辑时没有城市和level的情况
        // 如果当前地图配置中存在经纬度，则以该经纬度为中心点
        if (this.optionMap.lng !== "" && this.optionMap.lat !== "") {
          this.mapAPI.setCenter([this.optionMap.lng, this.optionMap.lat]);
        }
      } else {
        let opts = {
          subdistrict: 0, //获取边界不需要返回下级行政区
          extensions: "all", //返回行政区边界坐标组等具体信息
          level: level //查询行政级别为 市
        };
        let district = new AMap.DistrictSearch(opts);
        district.search(city, (status, result) => {
          if (this.polygons != []) {
            this.mapAPI.removeOverlay(this.polygons); //清除上次结果
            this.polygons = [];
          }
          let bounds = result.districtList[0].boundaries;
          if (bounds) {
            for (let i = 0, l = bounds.length; i < l; i++) {
              //生成行政区划polygon
              let polygon = new AMap.Polygon({
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0,
                fillColor: "#80d8ff",
                strokeColor: "#0091ea"
              });
              this.polygons.push(polygon);
            }
          }
          this.map.setFitView(this.polygons); //视口自适应
          // this.mapAPI.setFitView({ overlayList: this.polygons }); //视口自适应
          this.mapAPI.setZoom(10);
        });
      }
    },
    showMap() {
      this.smallMapDisplay = "block";
      // 根据城市名获取行政区域，用于设置地图中心视口
      this.getAreaByCity(this.optionMap.city, this.optionMap.level);
      // this.serachLocation();
      this.showMask = true;
      this.$refs.mapBox.showBox();
      if (!this.city) {
        this.$message({
          message: "未选择市区，搜索匹配结果可能不准确",
          type: "warning"
        });
      }
      this.loadQuery();
    },
    //点击“标点”
    drawMarker() {
      if (this.marker != null) {
        this.mapAPI.removeOverlay(this.marker); //清除之前的点
        this.map.clearMap(); // 清除地图上面的标点
      }
      if (this.infoWindow != null) {
        this.infoWindow.close(); //关闭之前的信息窗体
      }
      this.mapAPI.drawOverlay({
        type: "marker",
        iconImg: "/e6Images/bg_cluster.png",
        callback: this.drawMarkerBack
      });
    },
    drawMarkerBack(overlay) {
      this.marker = overlay;
      this.marker.setDraggable(true); //点可拖拽
      var lonlat = this.mapAPI.getPosition(overlay);
      this.lon = lonlat.lng;
      this.lat = lonlat.lat;
      this.mapAPI.getAddress([lonlat.lng, lonlat.lat], this.getAddressBack);
      this.handleDragEnd({ lnglat: lonlat });
      this.marker.on("dragend", marResult => {
        this.handleDragEnd(marResult);
      });
    },
    getAddressBack(address) {
      this.location = address.formattedAddress; //保存当前地址信息
    },
    //搜索地址
    serachLocation() {
      // 避免地图加载报错
      if (this.mapAPI !== null) {
        if (this.location != "") {
          // 根据 location 的地址查询对应的经纬度，并且声称对应的点
          this.mapAPI.getLocation(this.location, this.getLocationBack);
        }
      } else {
        setTimeout(() => {
          this.serachLocation();
        }, 10);
      }
    },
    // 根据地址查询到的经纬度展示相应的点
    getLocationBack(lnglat) {
      let llObj = this.mapAPI.createLngLat({
        lat02: lnglat.lat,
        lng02: lnglat.lng
      });
      this.mapAPI.setCenter(llObj);
      if (this.marker != null) {
        this.mapAPI.removeOverlay(this.marker);
        this.map.clearMap();
        this.marker = null;
      }
      this.lon = lnglat.lng;
      this.lat = lnglat.lat;
      this.marker = this.mapAPI.createMarker({
        position: llObj,
        width: 30,
        height: 38,
        icon: "/e6Images/bg_cluster.png",
        offset: new AMap.Pixel(-15, -19),
        draggable: true
      });
      this.mapAPI.addOverlay(this.marker);
      this.marker.on("dragend", marResult => {
        this.handleDragEnd(marResult);
      });
    },
    //点击确定
    sureMap() {
      var data = {
        lng: this.lon,
        lat: this.lat,
        location: this.location
      };
      this.$emit("showMapInfo", data);
      this.closeMap();
    },
    closeMap() {
      this.$refs.mapBox.closeBox();
      this.showMask = false;
      // setTimeout(function() {
      this.smallMapDisplay = "none";
      // }, 300);
    },
    cancelMap() {
      // this.clearData();
      this.closeMap();
    },
    clearData() {
      if (
        this.optionMap &&
        this.optionMap.lng != 0 &&
        this.optionMap.lat != 0
      ) {
        this.lon = this.optionMap.lng;
        this.lat = this.optionMap.lat;
      } else if (this.optionMap.location != "") {
        this.location = this.optionMap.location;
      } else {
        this.lon = 0;
        this.lat = 0;
        this.location = "";
        if (this.marker != null) {
          this.mapAPI.removeOverlay(this.marker);
        }
      }
    },
    //详情信息框
    showInfoOver(location, address) {
      this.infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -20)
      });
      // this.infoWindow.setPosition(location);
      this.infoWindow.setContent(
        `<p>详细信息</p>
          <p>地址:${address}</p>
          <p style="font-size:12px;color:#999"><i class="e6-icon-abnormal_line"></i>拖动蓝色标注，可调整位置</p>`
      ); //详情信息框
      this.mapAPI.setCenter(this.marker.getPosition());
      this.infoWindow.open(this.map, this.marker.getPosition());
    },
    //初始化poiPicker
    async loadQuery() {
      if (!global.AMapUI) await this.getAMapUI();
      AMapUI.loadUI(["misc/PoiPicker"], PoiPicker => {
        var poiPicker = new PoiPicker({
          city: this.city,
          input: this.$refs.pickerInput
        });

        //初始化poiPicker
        this.poiPickerReady(poiPicker);
      });
    },
    poiPickerReady(poiPicker) {
      window.poiPicker = poiPicker;

      this.marker = new AMap.Marker();

      //选取了某个POI
      poiPicker.on("poiPicked", poiResult => {
        let poi = poiResult.item; //选取的地点的位置相关信息
        this.marker.setMap(this.map); //为Marker指定目标显示地图
        // infoWindow.setMap(this.map);

        this.marker.setPosition(poi.location);
        this.marker.setDraggable(true); //点可拖拽
        let address = "";
        if (poi.district) {
          address = poi.district + poi.address + poi.name;
        } else {
          address =
            poi.pname + poi.cityname + poi.adname + poi.address + poi.name;
        }
        this.location = poi.address + poi.name; //点击确定之后回显的地址字符串
        // 设置该点的经纬度
        this.lon = poi.location.lng;
        this.lat = poi.location.lat;
        this.showInfoOver(poi.location, address);

        //若拖动marker，拖拽后获取新的位置信息
        this.marker.on("dragend", marResult => {
          this.handleDragEnd(marResult);
        });
      });
    },
    //点标记拖拽结束事件
    handleDragEnd(marResult) {
      let geocoder = new AMap.Geocoder();
      let lnglat = [marResult.lnglat.lng, marResult.lnglat.lat];
      this.marker.setPosition(lnglat);
      geocoder.getAddress(lnglat, (status, result) => {
        if (status === "complete" && result.regeocode) {
          let newAddress = result.regeocode.formattedAddress;
          this.location = newAddress;
          this.showInfoOver(lnglat, newAddress);
        } else {
          console.log("获取地址失败");
        }
      });
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   // lazyAMapApiLoaderInstance.load().then(() => {
    //   this.map = new AMap.Map("amapContainer", {
    //     center: new AMap.LngLat(108.942387, 34.261064),
    //     zoom: 14,
    //     lang: "zh-cn" //设置地图语言类型  zh-cn  en  zh-en
    //   });
    //   setTimeout(() => {
    //     this.map.addControl(new AMap.ToolBar());
    //     this.map.addControl(new AMap.Scale());
    //   }, 500);
    //   this.mapAPI = new GaodeAPI(this.map);
    //   // this.loadQuery();
    //   if (
    //     this.optionMap &&
    //     this.optionMap.lng != 0 &&
    //     this.optionMap.lat != 0
    //   ) {
    //     this.mapAPI.getAddress(
    //       [this.optionMap.lng, this.optionMap.lat],
    //       this.getAddressBack
    //     );
    //     this.lon = this.optionMap.lng;
    //     this.lat = this.optionMap.lat;
    //     this.marker = this.mapAPI.createMarker({
    //       position: [this.optionMap.lng, this.optionMap.lat],
    //       width: 30,
    //       height: 38,
    //       icon: "/e6Images/bg_cluster.png",
    //       offset: new AMap.Pixel(-15, -19)
    //       // draggable: true
    //     });
    //     this.mapAPI.addOverlay(this.marker);
    //     this.mapAPI.setCenter([this.optionMap.lng, this.optionMap.lat]);
    //     // this.marker.on("dragend", this.showInfoOver);
    //   } else if (this.optionMap.location != "") {
    //     this.location = this.optionMap.location;
    //     this.serachLocation();
    //   }
    //   // });
    // });
  }
};
</script>

<style lang="scss" scoped>
.mapDiv {
  width: 100%;
  height: 100%;
}
.maptool {
  position: absolute;
  top: 20px;
  right: 15px;
}
.smallmapBox {
  width: 650px;
  height: 500px;
  left: calc(50% - 325px);
  top: calc(50% - 250px);
  background: #fff;
  z-index: 9999;
}
.maskDiv {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.mapBtn_blude {
  background: #74c0fe;
  padding: 7px 10px;
  color: #fff;
  border-radius: 5px;
  margin: 0 5px;
  font-size: 12px;
  cursor: pointer;
}
.mapBtn {
  padding: 5px 10px;
  border-radius: 5px;
  margin: 0 5px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #ddd;
}
.mapInput {
  width: 320px;
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
/deep/.amap-drags .amap-icon img {
  width: 36px;
  height: 36px;
}
</style>
